
if (typeof Function.prototype.bind === 'undefined') {
  Function.prototype.bind = function (context) {
    var params = ([]).slice.call(arguments, 1);
    var fn = this;
    return function () {
      var allParams = params.concat(([]).slice.call(arguments, 0));
      return fn.apply(context, allParams);
    };
  };
};
module.exports = function anonymous(locals, escape, include, rethrow
/*``*/) {
escape = escape || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<!-- <div class=\"c-nav__header fl  \">\n</div>\n<div class=\"c-nav__body\">\n    <div class=\"c-slider\">\n    </div>\n</div> -->\n<div class=\"navbox clearfix\">\n	<ul class=\"option clearfix fl\">\n\n	</ul>\n	<a class=\"sort bt66 fl\"  id=\"js_sort\"><span>正序</span></a>\n	<a class=\"refresh bt66 fl\" id=\"js_refresh\"><span>刷新</span></a>\n</div>\n\n")
  }
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/modules/tab/tabTitle.ejs
// module id = 525
// module chunks = 0